/**
 * Chart Theme — copied from original console app
 * No Next.js-specific changes needed
 */

export const chartColors = {
  primary: "#06b6d4",
  secondary: "#14b8a6",
  tertiary: "#22c55e",
  quaternary: "#84cc16",
  quinary: "#eab308",
  success: "#22c55e",
  warning: "#f59e0b",
  error: "#ef4444",
  info: "#3b82f6",
};

export const defaultChartTheme = {
  axis: {
    stroke: "rgba(255, 255, 255, 0.1)",
    tickLine: false,
    axisLine: false,
  },
  axisLabel: {
    fill: "rgba(255, 255, 255, 0.5)",
    fontSize: 12,
  },
  grid: {
    strokeDasharray: "3 3",
    stroke: "rgba(255, 255, 255, 0.06)",
  },
  tooltip: {
    contentStyle: {
      backgroundColor: "rgba(15, 23, 42, 0.95)",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      borderRadius: "8px",
      padding: "8px 12px",
    },
    labelStyle: {
      color: "rgba(255, 255, 255, 0.7)",
      fontSize: 12,
      marginBottom: 4,
    },
    itemStyle: {
      color: "rgba(255, 255, 255, 0.9)",
      fontSize: 12,
    },
    cursor: {
      fill: "rgba(255, 255, 255, 0.05)",
    },
  },
  legend: {
    wrapperStyle: {
      fontSize: 12,
      color: "rgba(255, 255, 255, 0.7)",
    },
    iconSize: 10,
  },
};

export function getChartColor(index: number): string {
  const colors = [
    chartColors.primary,
    chartColors.secondary,
    chartColors.tertiary,
    chartColors.quaternary,
    chartColors.quinary,
    chartColors.info,
  ];
  return colors[index % colors.length]!;
}
